import { client } from "apollo";
import React from "react";
import ReactGA from "react-ga4";
import { createRoot } from "react-dom/client";
import { RecoilRoot } from "recoil";
import { DEV_MODE } from "util/constants";

import { ApolloProvider } from "@apollo/client";

import App from "./App";
import appSetup from "./setup";

appSetup(DEV_MODE);
ReactGA.initialize("G-JS91GTQD6Q");

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <ApolloProvider client={client}>
    <RecoilRoot>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </RecoilRoot>
  </ApolloProvider>
);
